import React from 'react';

import { useSelector } from 'react-redux';

import styles from './PayWithPointsModal.module.scss';

/**
 * Confirmation modal for paying for a coupon with points instead of cash —
 * used by ReserveCoupon (ReservedCoupon.js).
 *
 * Props:
 *   isVisible          — controls visibility
 *   setIsVisible        — close handler (setState-style, called with false)
 *   data                — coupon details (price used to compute points cost)
 *   onPayByPointsPress  — confirm handler
 */
const PayWithPointsModal = ({ isVisible, setIsVisible, data, onPayByPointsPress }) => {
  const totalPoints = useSelector(state => state.customerProfile?.data?.total_points ?? 0);

  if (!isVisible) return null;

  const pointsCost = Math.ceil((Number(data?.price) || 0) * 100);
  const canAfford = totalPoints >= pointsCost;

  const handleClose = () => setIsVisible(false);

  const handleConfirm = () => {
    setIsVisible(false);
    onPayByPointsPress();
  };

  return (
    <div className={styles.overlay} onClick={handleClose}>
      <div className={styles.content} onClick={e => e.stopPropagation()}>
        <h2 className={styles.title}>Pay With Points?</h2>
        <p className={styles.message}>
          This coupon costs <span className={styles.pointsCost}>{pointsCost} points</span>. You currently
          have {totalPoints} points.
        </p>
        {!canAfford && (
          <p className={styles.message} style={{ marginTop: '0.5rem' }}>
            You don&apos;t have enough points for this purchase.
          </p>
        )}
        <div className={styles.buttons}>
          <button type="button" className={styles.btnNo} onClick={handleClose}>
            Cancel
          </button>
          <button type="button" className={styles.btnYes} onClick={handleConfirm} disabled={!canAfford}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayWithPointsModal;